import type {AnyLinkType} from 'shared/pretty-easy-navigation/models';
import type {SearchFilterDefinition, SearchFilterValue} from 'shared/search-engine';
import {findMatchingLevelOption} from '../search/mathia-activity-search-dialog/mathia-activity-search-initial-selection';

export interface MathiaMenuClass {
    level?: string | number | null;
    archived?: boolean;
}

export function prefilterMathiaModelsMenu(
    menu: AnyLinkType[],
    groups: readonly MathiaMenuClass[],
    definitions: readonly SearchFilterDefinition<SearchFilterValue>[],
): AnyLinkType[] {
    const options = definitions.find(definition => definition.key === 'level')?.options ?? [];
    const levels = [...new Set(groups
        .filter(group => !group.archived)
        .map(group => findMatchingLevelOption(group.level, options)?.value)
        .filter((level): level is string | number => typeof level === 'number' || typeof level === 'string')
        .map(level => String(level).trim())
        .filter(level => level !== ''))];

    return menu.map(item => {
        if (item.type === 'linkGroup' || item.type === 'accordionLinkGroup') {
            return {...item, links: prefilterMathiaModelsMenu(item.links, groups, definitions)};
        }

        if (item.type !== 'link' || item.link !== '/lessons/list/models') {
            return item;
        }

        const queryParams = {...item.queryParams};
        if (levels.length > 0) {
            queryParams.educationalLevel = levels.join(',');
        } else {
            delete queryParams.educationalLevel;
        }

        return {...item, queryParams};
    });
}
